<template>


    <div class="sight1_survey">

        <div v-if="sight2survey.questions.q01">

            <div class="survey_order">{{ sight2survey.order }}</div>

            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 1" >
                    <QuestionRadios :label="sight2survey.questions.q01" questionId="q01" v-model="sight2Responses.q01" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q02" questionId="q02" v-model="sight2Responses.q02" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q03" questionId="q03" v-model="sight2Responses.q03" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q04" questionId="q04" v-model="sight2Responses.q04" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q05" questionId="q05" v-model="sight2Responses.q05" @input="setResponsesNumber" />
                </div>
            </transition>

            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 2" >
                    <QuestionRadios :label="sight2survey.questions.q06" questionId="q06" v-model="sight2Responses.q06" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q07" questionId="q07" v-model="sight2Responses.q07" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q08" questionId="q08" v-model="sight2Responses.q08" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q09" questionId="q09" v-model="sight2Responses.q09" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q10" questionId="q10" v-model="sight2Responses.q10" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 3" >
                    <QuestionRadios :label="sight2survey.questions.q11" questionId="q11" v-model="sight2Responses.q11" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q12" questionId="q12" v-model="sight2Responses.q12" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q13" questionId="q13" v-model="sight2Responses.q13" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q14" questionId="q14" v-model="sight2Responses.q14" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q15" questionId="q15" v-model="sight2Responses.q15" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 4" >
                    <QuestionRadios :label="sight2survey.questions.q16" questionId="q16" v-model="sight2Responses.q16" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q17" questionId="q17" v-model="sight2Responses.q17" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q18" questionId="q18" v-model="sight2Responses.q18" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q19" questionId="q19" v-model="sight2Responses.q19" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q20" questionId="q20" v-model="sight2Responses.q20" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 5" >
                    <QuestionRadios :label="sight2survey.questions.q21" questionId="q21" v-model="sight2Responses.q21" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q22" questionId="q22" v-model="sight2Responses.q22" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q23" questionId="q23" v-model="sight2Responses.q23" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q24" questionId="q24" v-model="sight2Responses.q24" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q25" questionId="q25" v-model="sight2Responses.q25" @input="setResponsesNumber" />
                </div>
            </transition>
            <transition name="question-slide">
                <div class="question_block" v-show="currentBlock == 6" >
                    <QuestionRadios :label="sight2survey.questions.q26" questionId="q26" v-model="sight2Responses.q26" @input="setResponsesNumber" />
                    <QuestionRadios :label="sight2survey.questions.q27" questionId="q27" v-model="sight2Responses.q27" @input="setResponsesNumber" />
                </div>
            </transition>
        </div>

    </div>

</template>

<script>
import QuestionRadios from '../questions/questionRadios'

export default {
    name: 'Sight2Survey',
    components: {
        QuestionRadios
    },
    data(){
        return {
            reponsesIdsArray: []
        }
    },
    computed: {
        sight2survey(){
            return this.$store.state.CandidateStore.sight2Survey
        },
        sight2Responses(){
            return this.$store.state.CandidateStore.sight2Responses
        },
        currentBlock(){
            if(this.reponsesIdsArray.length < 5){ return 1 }
            else if(this.reponsesIdsArray.length < 10){ return 2 }
            else if(this.reponsesIdsArray.length < 15){ return 3 }
            else if(this.reponsesIdsArray.length < 20){ return 4 }
            else if(this.reponsesIdsArray.length < 25){ return 5 }
            else if(this.reponsesIdsArray.length < 30){ return 6 }
            else{ return -1 }
        }
    },
    methods: {
        setResponsesNumber(value, qId){
            if(!this.reponsesIdsArray.includes(qId)){
                this.reponsesIdsArray.push(qId)
            }
        }
    },
    watch: {
        reponsesIdsArray: function(newVal, oldVal){
            if(newVal.length == 27){
                this.$store.commit('CandidateStore/saveResponses', { surveyName: 'sight2', survey: this.sight2Responses } )
                this.$emit('surveyCompleted', 'sight2')
            }
        }
    }
}

</script>

<style lang="scss">
</style>